module.exports = __webpack_public_path__ + "img/AIDIGY.b0f6e34f.svg";